export default __webpack_public_path__ + "static/media/black.f5e2ffee.png";